import React from 'react';

const DownloadIcon = (props) => {

  const { colorLines, colorBackground, className, onClick } = props;

  return (
    <div className={className} onClick={onClick}>
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="42" height="42" rx="21" fill={colorBackground}/>
            <g transform="translate(5.25 5.25) scale(0.75)">
                <path d="M20.2929 29.2671C20.6834 29.6576 21.3166 29.6576 21.7071 29.2671L28.0711 22.9031C28.4616 22.5126 28.4616 21.8794 28.0711 21.4889C27.6805 21.0984 27.0474 21.0984 26.6569 21.4889L21 27.1458L15.3431 21.4889C14.9526 21.0984 14.3195 21.0984 13.9289 21.4889C13.5384 21.8794 13.5384 22.5126 13.9289 22.9031L20.2929 29.2671ZM20 6.71997L20 28.56H22L22 6.71997H20Z" fill={colorLines}/>
                <line x1="10.8301" y1="34.53" x2="31.1701" y2="34.53" stroke={colorLines} strokeWidth="1.5" strokeLinecap="round"/>
            </g>
        </svg>
    </div>
    );
}

export default DownloadIcon;